import * as React from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { Alert, CssBaseline, Grid, Skeleton } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import '../../../Css/Global/Global.css';
import {useState} from "react";
import {verifyTwoFactorCode} from "../../../Requests";
import VerificationCodeInput from "./VerificationCodeInput";
import {maskEmail} from "../../../Helpers";
import {authData} from "../../../Storages";
import CompetenciaStorageUtils from "../../../Storages/competenciaStorage";

interface ITwoFactorForm {
    setTwoFactor: React.Dispatch<React.SetStateAction<boolean>>;
}

const TwoFactorForm: React.FC<ITwoFactorForm> = ({setTwoFactor}) => {
    const [isLoadingVerify, setIsLoadingVerify] = React.useState<boolean>(false);
    const [code, setCode] = React.useState<string[]>([]);
    const navigate = useNavigate();
    const {email = ''} = authData.get();
    const maskedEmail = maskEmail(email);
    const [twoFactorMessage, setTwoFactorMessage] = useState<{message: string, status: "error" | "success" | "info" | "warning"}>({message: '', status: 'warning'});

    async function verifyCode() {
        setIsLoadingVerify(true);
        setTwoFactorMessage({message: '', status: 'warning'});

        const body = {
            email: email,
            code: code.join(""),
        };

        if(email === '') {
            setIsLoadingVerify(false);
            return new Promise((resolve, reject) => {resolve(null)});
        }

        const response = await verifyTwoFactorCode.post(body);

        const {
            message = 'Houve um erro na verificação de dois fatores',
            status = 'error',
            newAttemptAllowed = false
        } = response

        setTwoFactorMessage({message, status});

        if (response?.status === "success") {
            // Limpa a competência selecionada do localStorage quando faz login
            CompetenciaStorageUtils.clear();
            
            setIsLoadingVerify(false);
            return navigate("/");
        }

        if (!newAttemptAllowed) {
            setTwoFactor(false);
        }

        setIsLoadingVerify(false);
    }

    React.useEffect(() => {

        const isCodeFilled = code.every(digit => digit !== '') && code.length === 6;

        if (isCodeFilled) {
            verifyCode();
        }
    }, [code]);

    return (
        <Grid container component="main" sx={{ height: '100vh' }}>
            <CssBaseline />
            <Grid item xs={12}>
                <Box
                    sx={{
                        mt: 22,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <img alt="TribuNex - Sistema de gestão tributária" src="img/logo.png" className="loginImg" />


                    <Typography component="h1" variant="h5" mt={4}>
                        Verificação de dois fatores!
                    </Typography>
                    <Typography sx={{ m: 2, maxWidth: 400 }}>
                        Prezado usuário, para garantir a segurança de sua conta, insira o código
                        que enviamos para o seu email {maskedEmail}.
                    </Typography>
                    <Box component="form" noValidate sx={{ mt: 4 }}>
                        <Grid container>
                            <Grid item xs={12}>
                                <VerificationCodeInput setCode={setCode} isLoadingVerify={isLoadingVerify}/>
                            </Grid>
                            <Grid item xs={12} mt={4}>
                                <Button
                                    type="button"
                                    fullWidth
                                    variant="contained"
                                    sx={{ mt: 2, mb: 2, background: "#1c2e4a" }}
                                    disabled={true}
                                    onClick={verifyCode}
                                >
                                    {isLoadingVerify ? (
                                        <Skeleton variant="circular" width={24} height={24} />
                                    ) : (
                                        "Verificar Código"
                                    )}
                                </Button>
                            </Grid>
                            {twoFactorMessage.message &&
                                <Grid item xs={12}>
                                    <Alert severity={twoFactorMessage.status}>{twoFactorMessage.message}</Alert>
                                </Grid>
                            }
                        </Grid>
                    </Box>
                </Box>

            </Grid>
        </Grid>
    );
}

export default TwoFactorForm;
